<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="2" xs="12">
        <div class="form-group">
          <label>Trạng thái</label>
          <select class="form-control" v-model="statusInput.data.model" @change="loadDataMainTable(true)">
            <option value="in">Chưa xuất</option>
            <option value="out">Đã xuất</option>
            <option value="">Tất cả</option>
          </select>
        </div>
      </CCol>
      <CCol sm="2" xs="12">
        <div class="form-group">
          <label>Nhà mạng</label>
          <select class="form-control" v-model="carrierInput.data.model" @change="loadDataMainTable(true)">
            <option value="">Tất cả</option>
            <option v-for="item in carriers" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput :options="keywordInput.options" :data="keywordInput.data" />
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput :options="sourceInput.options" :data="sourceInput.data" />
      </CCol>
      <CCol class="text-right">
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton color="primary" v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <div class="d-flex flex-wrap mb-3">
      <CButton color="primary" size="sm" class="mr-2 mb-2" :disabled="selectedBlank.length === 0" @click="openBulk('activate')">
        Kích hoạt đã chọn ({{ selectedBlank.length }})
      </CButton>
      <CButton color="info" size="sm" class="mr-2 mb-2" :disabled="selectedActive.length === 0" @click="openBulk('extend')">
        Gia hạn đã chọn ({{ selectedActive.length }})
      </CButton>
      <CButton color="warning" size="sm" class="mr-2 mb-2" :disabled="selectedActive.length === 0" @click="openBulk('correct')">
        Sửa đã chọn ({{ selectedActive.length }})
      </CButton>
      <CButton color="danger" size="sm" class="mr-2 mb-2" :disabled="selectedActive.length === 0" @click="openBulk('cancel')">
        Hủy kích hoạt ({{ selectedActive.length }})
      </CButton>
    </div>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="text-center">
              <input type="checkbox" :checked="isSelected(item)" @change="toggleSelected(item)" />
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <span class="badge" :class="item.stockType === 'out' ? 'badge-warning' : 'badge-success'">
                {{ item.stockType === 'out' ? 'Đã xuất' : 'Chưa xuất' }}
              </span>
              <div v-if="!item.stockType"><small>Chưa nhập kho</small></div>
              <div v-else-if="item.stockType === 'in'"><small>Trong kho</small></div>
            </td>
          </template>
          <template #activation="{ item }">
            <td class="text-nowrap">
              <span v-if="item.startDate && item.expireDate" class="badge badge-success">Đã kích hoạt</span>
              <span v-else class="badge badge-secondary">Chưa kích hoạt</span>
            </td>
          </template>
          <template #startDate="{ item }">
            <td class="text-nowrap">{{ formatDate(item.startDate) }}</td>
          </template>
          <template #expireDate="{ item }">
            <td class="text-nowrap">{{ formatDate(item.expireDate) }}</td>
          </template>
          <template #activatedDate="{ item }">
            <td class="text-nowrap">{{ formatDate(item.activatedDate) }}</td>
          </template>
          <template #extendDate="{ item }">
            <td class="text-nowrap">{{ formatDate(item.extendDate) }}</td>
          </template>
          <template #importDate="{ item }">
            <td class="text-nowrap">{{ formatDate(item.importDate) }}</td>
          </template>
          <template #inFrom="{ item }">
            <td>
              <div>{{ item.inDocumentNo || '-' }}</div>
              <small v-if="item.inCustomerName">{{ item.inCustomerName }}</small>
            </td>
          </template>
          <template #outTo="{ item }">
            <td>
              <div v-if="item.stockType === 'out'">
                <div>{{ item.documentNo }}</div>
                <small>{{ item.customerName }}</small>
                <div><small>{{ $helper.stockPurposeLabel('out', item.purpose) }}</small></div>
                <small v-if="item.accountingDate">{{ formatDate(item.accountingDate) }}</small>
              </div>
              <span v-else>-</span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="!item.startDate && !item.expireDate" color="primary" variant="outline" square size="sm"
                  v-c-tooltip.hover="'Kích hoạt'" @click="$refs.packageForm.open(item, 'activate')">
                  <i class="fa fa-check"></i>
                </CButton>
                <template v-else>
                  <CButton color="info" variant="outline" square size="sm" v-c-tooltip.hover="'Gia hạn'"
                    @click="$refs.packageForm.open(item, 'extend')">
                    <i class="fa fa-calendar-plus-o"></i>
                  </CButton>
                  <CButton color="warning" variant="outline" square size="sm" v-c-tooltip.hover="'Sửa kích hoạt'"
                    @click="$refs.packageForm.open(item, 'correct')">
                    <i class="fa fa-pencil"></i>
                  </CButton>
                  <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Hủy kích hoạt'"
                    @click="$refs.packageForm.open(item, 'cancel')">
                    <i class="fa fa-undo"></i>
                  </CButton>
                </template>
                <CButton color="secondary" variant="outline" square size="sm" v-c-tooltip.hover="'Xem lô'"
                  @click="$router.push(`/sim-management/${item.lotId}/update.html`)">
                  <i class="fa fa-folder-open"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <SimPackageForm ref="packageForm" @saved="onPackageSaved"></SimPackageForm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import BaseInput from "../base/BaseInput";
import SimPackageForm from "./PackageForm";

export default {
  name: "SimCardList",
  components: { BaseTable, BaseInput, SimPackageForm },
  notifications: {
    showSuccessMsg: { type: "success", title: "Success" },
    showErrorMsg: { type: "error", title: "Error" }
  },
  data() {
    let that = this;
    return {
      carriers: ["Viettel", "MobiFone", "VinaPhone", "Vietnamobile", "Gmobile", "Itel", "Wintel", "Reddi"],
      selected: {},
      statusInput: {
        data: {
          name: "status",
          model: "in"
        }
      },
      carrierInput: {
        data: {
          name: "carrier",
          model: ""
        }
      },
      keywordInput: {
        options: {
          placeholder: "IMEI / SĐT / ICCID",
          label: "Tìm sim"
        },
        data: {
          name: "keyword",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      sourceInput: {
        options: {
          placeholder: "Nhà cung cấp, đại lý...",
          label: "Nhập từ"
        },
        data: {
          name: "source",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "checkbox", label: "", sorter: false, filter: false },
            { key: "carrier", label: "Nhà mạng" },
            { key: "imei", label: "IMEI" },
            { key: "phone", label: "SĐT" },
            { key: "iccid", label: "ICCID" },
            { key: "lotName", label: "Lô" },
            { key: "source", label: "Nhập từ" },
            { key: "importDate", label: "Ngày nhập lô" },
            { key: "activation", label: "Kích hoạt" },
            { key: "startDate", label: "Ngày bắt đầu" },
            { key: "expireDate", label: "Ngày hết hạn" },
            { key: "activatedDate", label: "Ngày kích hoạt" },
            { key: "extendDate", label: "Ngày gia hạn" },
            { key: "status", label: "Trạng thái" },
            { key: "inFrom", label: "Phiếu nhập" },
            { key: "outTo", label: "Xuất cho" },
            { key: "action", label: "Thao tác", sorter: false, filter: false }
          ],
          slots: ["checkbox", "importDate", "status", "activation", "startDate", "expireDate", "activatedDate", "extendDate", "inFrom", "outTo", "action"],
          sorter: true,
          columnFilter: false,
          hover: false,
          itemsPerPageSelect: { label: " ", values: [15, 20, 30, 50, 100], external: true },
          pageSize: 20
        },
        dataSource: {
          url: "/sim/card-pages",
          dataSubmit: function () {
            return {
              status: that.statusInput.data.model,
              carrier: that.carrierInput.data.model,
              keyword: that.keywordInput.data.model,
              source: that.sourceInput.data.model
            };
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  computed: {
    selectedSims() {
      return Object.keys(this.selected).map((id) => this.selected[id]);
    },
    selectedBlank() {
      return this.selectedSims.filter(function (item) {
        return !item.startDate && !item.expireDate;
      });
    },
    selectedActive() {
      return this.selectedSims.filter(function (item) {
        return item.startDate && item.expireDate;
      });
    }
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.selected = {};
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    formatDate(value) {
      return this.$helper.formatDateDDMMYYYY(value);
    },
    simKey(item) {
      return String(item.id);
    },
    isSelected(item) {
      return !!this.selected[this.simKey(item)];
    },
    toggleSelected(item) {
      const key = this.simKey(item);
      if (this.selected[key]) {
        this.$delete(this.selected, key);
      } else {
        this.$set(this.selected, key, item);
      }
    },
    openBulk(mode) {
      const rows = mode === "activate" ? this.selectedBlank : this.selectedActive;
      if (!rows.length) {
        this.showErrorMsg({
          message: mode === "extend" ? "Chọn sim đã kích hoạt để gia hạn" : mode === "activate" ? "Chọn sim chưa kích hoạt" : "Chọn sim đã kích hoạt"
        });
        return;
      }
      this.$refs.packageForm.openList(rows, mode);
    },
    onPackageSaved() {
      this.selected = {};
      this.loadDataMainTable(false);
    }
  }
};
</script>
